import { CardMedia, colors, Link, Typography, CardActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import LoadingIndicator from 'components/LoadingIndicator';
import PropTypes from 'prop-types';
import React, { Fragment, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { RenderGuard } from 'components';


const useStyles = makeStyles(theme => ({
  root: {},
  dropZone: {
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  },
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5
  },
  image: {
    width: 130
  },
  info: {
    marginTop: theme.spacing(1)
  },
  list: {
    maxHeight: 320
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  error: {
    flex: 1
  },
  media: {
    height: 240
  },
}));

const ImageDropzone = props => {
  const { className, file, setFile, types = [], error, setError, fileLoading, handleUpload, image, ...rest } = props;
  const classes = useStyles();
  const [preview, setPreview] = useState(null);
  const mimes = ["image/jpeg", "image/png"];

  const handleDrop = useCallback(acceptedFile => {
    setFile(acceptedFile[0]);
    setPreview(URL.createObjectURL(acceptedFile[0]))
    setError(null);
    // eslint-disable-next-line
  }, []);

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop: handleDrop,
  });

  const clear = () => {
    setFile(null);
    setPreview(null);
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <input {...getInputProps()} accept={mimes} />
      {!image && !file && !fileLoading &&
        <div
          className={clsx({
            [classes.dropZone]: true,
            [classes.dragActive]: isDragActive
          })}
          {...getRootProps()}
        >
          <div>
            <img
              alt="Select"
              className={classes.image}
              src="/images/undraw_add_file2_gvbb.svg"
            />
          </div>
          <div>
            <Typography
              gutterBottom
              variant="h3"
            >
              Select Image
            </Typography>
            <Typography
              className={classes.info}
              color="textSecondary"
              variant="body1"
            >
              Drop image here or click to <Link underline="always">browse</Link>{' '}
              through your machine
          </Typography>
            {types && types.length > 0 && (
              <Typography
                className={classes.info}
                color="textSecondary"
                variant="body1"
              >
                Only {types.reduce((acc, val) => acc + val.format + ", ", "").slice(0, -2)} filetypes accepted
              </Typography>
            )}
          </div>
        </div>
      }
      <LoadingIndicator active={fileLoading} variant="card" />
      {(preview || (image && image.uri)) && <CardMedia
        className={classes.media}
        image={preview ? preview : image.uri}
      />
      }
      <CardActions>
        <RenderGuard renderIf={file}>
          <Fragment>
            <Button fullWidth className={classes.closeButton} onClick={clear} >Cancel</Button>
            <Button fullWidth className={classes.closeButton} onClick={() => handleUpload()} >Upload</Button>
          </Fragment>
        </RenderGuard>
        <RenderGuard renderIf={image && !file}>
          <Button fullWidth className={classes.closeButton} onClick={open}>Change Image</Button>
        </RenderGuard>
      </CardActions>

    </div>
  );
};

ImageDropzone.propTypes = {
  className: PropTypes.string
};

export default ImageDropzone;
